module.exports = __webpack_public_path__ + "img/tool.971fc974.svg";